import './Contact.css';
import Icon from "./Icon";
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const scriptURL = `https://script.google.com/macros/s/${API_KEY}/exec`;


function snackbar(message) {
  var x = document.getElementById("snackbar");
  x.className = "show";
  x.innerHTML = message;
  setTimeout(function() {
      x.className = x.className.replace("show", "")
  }, 4000)
}
  

  export default function Contact(){
    function onSubmit(e) 
  {const form = document.forms['contact'];
    document.getElementById("overlay").style.display = "block";
    e.preventDefault();
    fetch(scriptURL, {
        method: 'POST',
        body: new FormData(form)
    }).then(response => {
        document.getElementById("overlay").style.display = "none";
        form.reset();
        snackbar(`<i class="fa fa-envelope" aria-hidden="true"></i> 
Message Sent <i class="fa fa-paper-plane" aria-hidden="true"></i>
`)
    }).catch(error => {
      document.getElementById("overlay").style.display = "none";
        snackbar(error.message);
        form.reset()
    }
    )

  }
    return (

        <div className="row">
          <div className="column">
            <form onSubmit={onSubmit} method="post" autoComplete="off" name="contact">
              <h2 id="heading">Contact ME</h2>
              <input type="email" title="Type your email address" id="email" name="Email" placeholder=" Your Email Address" required/>
              <textarea id="message" title="Type your Message" name="Message" placeholder=" Your Message ..." defaultValue={""} required></textarea>
              <input type="submit" title="Send your Message" value="Send " defaultValue="Send " />
            </form>
          </div>
          <div className="column">
            <div className="alignment">
            <Icon name="social-icon"/>
              <div className="footnote">
                <div className="mail"><a href="mailto:rupakc770@gmail.com">rupakc770@gmail.com</a></div>
                <ul className="social">
                  <li><a href="https://www.facebook.com/me.rpkc" ><i className="fa fa-facebook-square" aria-hidden="true" /></a></li>
                  <li><a href="https://www.instagram.com/rpk.c/" ><i className="fa fa-instagram" aria-hidden="true" /></a></li>
                  <li><a href="https://twitter.com/rupk_c"><i className="fa fa-twitter" aria-hidden="true" /></a></li>
                  <li><a href="https://github.com/rpkc"><i className="fa fa-github" aria-hidden="true" /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
}

